<template>
<div 
  class="language-selector"
  js-noremove
  >
    <div class="language"
      :data-anim="isMobile() ? false : ''"
    >
      <a
        href="#!"
        :class="['language__link', `language__link--${languages[active].slug}`]"
        @click.prevent="switchLang(languages[active].slug)"
        data-mouse
        data-mouse-attractionstate="active"
        data-mouse-attractionval="20"
        data-mouse-magnetism="5"
        data-hover-type="lang"
      >
        <img :src="`/static/img/lang/${languages[active].slug}.svg`" class="lang" :alt="`${languages[active].name} icon link`"/>
      </a>
  </div>
</div>
</template>

<script>
import store from '@/store';
import { mapGetters } from 'vuex';

import { TweenLite, Expo } from 'gsap/TweenMax';

import { qs, viewportSize, isMobile } from '@/scripts/utils';


export default {
  name: 'SwitchLang',

  data() {
    return {
      isMobile,

      languages: {
        it: {
          name: 'It',
          slug: 'it',
          active: store.getters.getLang === 'it',
        },

        en: {
          name: 'En',
          slug: 'en',
          active: store.getters.getLang === 'en',
        },
      },
      scale: 0,
    };
  },

  computed: {
    ...mapGetters({
      lang: 'getLang',
    }),

    active() {
      return this.lang === 'it' ? 'en' : 'it';
    },
  },

  mounted() {
    this.setScale();
  },

  methods: {
    switchLang(lang) {
      const circleSwitch = qs('.el-transition');
      this.setScale();

      circleSwitch.classList.add('active');

      this.$store.commit('IS_CHANGING_LANG', true);

      TweenLite.to(circleSwitch, 2, {
        scale: this.scale,
        ease: Expo.easeInOut,
        onComplete: () => {
          this.$store.commit('CHANGE_LANG', lang);

          if (this.$store.state.route.name === 'home') {
            this.$router.push(`/${lang}`);
          } else {
            this.$router.push(`/${lang}/${this.$store.state.currentEventData.translate}`);
          }

          TweenLite.to(circleSwitch, 2, {
            scale: 0,
            ease: Expo.easeInOut,
            onComplete: () => {
              circleSwitch.classList.remove('active');

              this.$store.commit('IS_CHANGING_LANG', false);
            },
          });
        },
      });
    },

    setScale() {
      const ratio = viewportSize().ratio;
      const width = viewportSize().width;
      const height = viewportSize().height;

      const refWidth = this.$el.getBoundingClientRect().width;
      const refHeight = this.$el.getBoundingClientRect().height;

      const ref = ratio >= 1 ? width : height;
      const refDelta = ratio >= 1 ? refWidth : refHeight;

      this.scale = (ref / refDelta) * 5;
    },
  },
};
</script>

<style lang="scss" scoped>
.language-selector {
  display: inline-block;
  position: relative;
  margin-left: 5px;

  .language__link {
    display: inline-block;
    width: 45px;
    padding: 10px;

    &.language__link--it {
      width: 45px;
      padding: 16px;
    }

    img {
      width: 100%;
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/components/header/SwitchLang.vue